import { CommonModule }                                         from '@angular/common';
import { HttpClient }                                           from '@angular/common/http';
import { ModuleWithProviders, NgModule, Type }                  from '@angular/core';
import { ComponentTranslationLoaderService, CsCultureProvider } from '@cs/common';
import { CsSharedModule }                                       from '@cs/components/shared';
import { LoggerUtil }                                           from '@cs/core';
import { CsTranslationLoader, IConfigService }                  from '@cs/performance-manager/shared';
import { CsApplicationSettings }                                from '@cs/common';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { IframeDocumentationConfigService } from './iframe-documentation-config.service';
import { IframeDocumentationRoutingModule } from './iframe-documentation-routing.module';
import { IframeDocumentationComponent }     from './iframe-documentation.component';

export function iframeDocumentationTranslationLoader(client: HttpClient,
																																																					pmAppSettings: CsApplicationSettings,
																																																					service: IConfigService,
																																																					componentLoader: ComponentTranslationLoaderService) {
	return new CsTranslationLoader(`${pmAppSettings.translationLocation}/${service.moduleName}`,
								   client, componentLoader);
}

@NgModule({
			  declarations: [IframeDocumentationComponent],
			  imports:      [
						CommonModule,
						CsSharedModule,
						TranslateModule.forChild({
											   loader:  {
												   provide:    TranslateLoader,
												   useFactory: iframeDocumentationTranslationLoader,
												   deps:       [HttpClient, CsApplicationSettings, IframeDocumentationConfigService,
																												ComponentTranslationLoaderService]
											   },
											   isolate: true
										   }),
						IframeDocumentationRoutingModule
			  ]
		  })
export class PmIframeDocumentationModule {
	static forRoot(moduleConfig: Type<IframeDocumentationConfigService>,
				   appSetting: CsApplicationSettings): ModuleWithProviders<PmIframeDocumentationModule> {
		return {
			ngModule:  PmIframeDocumentationModule,
			providers: [
				{
					provide:  IframeDocumentationConfigService,
					useClass: moduleConfig
				},
				{
					provide:  CsApplicationSettings,
					useValue: appSetting
				}
			]
		};
	}

	constructor(translate: TranslateService, culture: CsCultureProvider) {

		if (!translate) {
			LoggerUtil.warn('Translation service is not set-up');
			return;
		}

		// this language will be used as a fallback when a translation isn't found in the current language
		translate.setDefaultLang(culture.getDefaultCulture());

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		translate.use(culture.getCulture());
	}
}
